import { X } from "lucide-react";

export default function EditorialPilotDialog({ title, onClose, children, testid }) {
  return (
    <div
      className="fixed inset-0 z-[70] flex items-center justify-center bg-black/45 px-4 py-6"
      onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}
      data-testid={testid}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        className="flex max-h-[86vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl border border-espresso/10 bg-cream shadow-2xl"
      >
        <div className="flex items-center gap-3 border-b border-espresso/10 px-5 py-4">
          <h2 className="flex-1 font-serif text-2xl text-espresso">{title}</h2>
          <button type="button" onClick={onClose} aria-label="Закрыть"
            className="rounded-full p-2 text-espresso/65 hover:bg-espresso/5 hover:text-espresso">
            <X className="h-4 w-4" />
          </button>
        </div>
        <div className="overflow-y-auto p-5">{children}</div>
      </div>
    </div>
  );
}
